import React from 'react';
import PropTypes from 'prop-types';

export default function UploadStatus({ files, onCancel, progress }) {
  const handleClick = evt => {
    evt.preventDefault();
    onCancel();
  };

  return (
    <div>
      <h3>
        Uploading {files} {files === 1 ? 'file' : 'files'}
        ...
      </h3>
      <va-progress-bar percent={progress * 100} />
      <p>Your files are uploading. Please do not close this window.</p>
      <va-button secondary text="Cancel" onClick={handleClick} />
    </div>
  );
}

UploadStatus.propTypes = {
  files: PropTypes.number,
  progress: PropTypes.number,
  onCancel: PropTypes.func,
};
